import React, { useState } from 'react';
import 'aos/dist/aos.css';
import './teamCard.scss';

const TeamCard = ({ imageSrc, name, role, bio, imgClass }) => {
  const [flipped, setFlipped] = useState(false);

  const handleClick = () => {
    if (!flipped) {
      setFlipped(true);

      // Automatically flip back after 10 seconds (10,000 ms)
      setTimeout(() => {
        setFlipped(false);
      }, 10000);
    } else {
      // Allow manual flip-back if user clicks again
      setFlipped(false);
    }
  };

  return (
    <div className={`team-card ${flipped ? 'flipped' : ''}`} onClick={handleClick}>
      <div className="team-card-inner">
        <div className="team-card-front">
          <div className="team-card-image-wrapper">
            <img
              src={imageSrc}
              alt={name}
              className={`team-card-image ${!!imgClass ? 'imgClass' : ''}`}
            />
          </div>
          <div className="team-card-content">
            <h3 className="team-card-name">{name}</h3>
            <p className="team-card-role">{role}</p>
          </div>
        </div>

        <div className="team-card-back">
          <div className="team-card-back-overlay">
            <p className="team-card-bio">{bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
